import { useId, useLayoutEffect, useRef } from "react"

import Stars45 from "@/assets/svg/rating/stars4.5.svg?react"
import Stars46 from "@/assets/svg/rating/stars4.6.svg?react"
import Stars47 from "@/assets/svg/rating/stars4.7.svg?react"
import Stars48 from "@/assets/svg/rating/stars4.8.svg?react"
import Stars49 from "@/assets/svg/rating/stars4.9.svg?react"
import Stars50 from "@/assets/svg/rating/stars5.0.svg?react"

interface RatingStarsProps {
  rating: number
  className?: string
}

const STARS = {
  "4.6": Stars46,
  "4.7": Stars47,
  "4.8": Stars48,
  "4.9": Stars49,
  "5.0": Stars50,
} as const

/** Renders the pre-drawn star-rating SVG for a given rating (4.5–5.0). */
export function RatingStars({ rating, className }: RatingStarsProps) {
  const uid = useId().replace(/:/g, "")
  const wrapRef = useRef<HTMLSpanElement>(null)
  const Icon = STARS[String(rating) as keyof typeof STARS] ?? Stars45

  // Duplicate mask ids across inlined copies make later rows look fully filled.
  useLayoutEffect(() => {
    const svg = wrapRef.current?.querySelector("svg")
    if (!svg) return
    for (const node of svg.querySelectorAll(":scope [id]")) {
      const oldId = node.id
      if (!oldId) continue
      const nextId = `${oldId}-${uid}`
      node.id = nextId
      svg.querySelectorAll(`[mask="url(#${oldId})"]`).forEach((el) => {
        el.setAttribute("mask", `url(#${nextId})`)
      })
    }
  }, [uid, rating])

  return (
    <span ref={wrapRef} className="contents" data-slot="rating-stars">
      <Icon className={className} />
    </span>
  )
}
